// @core/api/endpoints/project/update_board.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BoardResponse,
  UpdateBoardRequest,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Update board
 * Updates board settings such as column names, order, WIP limits, and display configuration. Changes affect all users viewing the board.
 */
export async function UpdateBoard(
  project_id: string,
  board_id: string,
  data: UpdateBoardRequest,
  options?: RequestOptions
): Promise<BoardResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/boards/:board_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':board_id', encodeURIComponent(board_id));
  const requestOptions = options;
  return client.put<BoardResponse>(requestPath, data, requestOptions);
}
